"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FocusLockWrapper = void 0;

var React = _interopRequireWildcard(require("react"));

var _focusLayers = require("./focus-layers");

var _utilities = require("@doordash/utilities");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getIsReactElement = function getIsReactElement(child) {
  if (typeof child === 'string' || typeof child === 'number') {
    return false;
  }

  if (child.type && child.type === React.Fragment) {
    return false;
  }

  return true;
};

var FocusLockWrapper = function FocusLockWrapper(_ref) {
  var children = _ref.children;
  var containerRef = React.useRef(null);
  (0, _focusLayers.useFocusLock)(containerRef);
  var firstChild = React.Children.only(children); // TODO: replace with more explicit element type that includes `ref`

  var childIsReactElement = getIsReactElement(firstChild);
  var existingInnerRef = childIsReactElement ? firstChild.ref : undefined;
  var combinedRef = (0, _utilities.useCombinedRef)(existingInnerRef, containerRef);

  if (!childIsReactElement) {
    console.error('You can not pass a non element as the child of FocusLock');
    return null;
  }

  var childWithRef = /*#__PURE__*/React.cloneElement(firstChild, {
    ref: combinedRef
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_focusLayers.FocusGuard, null), childWithRef, /*#__PURE__*/React.createElement(_focusLayers.FocusGuard, null));
};

exports.FocusLockWrapper = FocusLockWrapper;

var FocusLock = function FocusLock(_ref2) {
  var disableFocusLock = _ref2.disableFocusLock,
      children = _ref2.children;

  if (disableFocusLock) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  return /*#__PURE__*/React.createElement(FocusLockWrapper, null, children);
};

var _default = FocusLock;
exports["default"] = _default;